import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import {Layout} from '../Common';
import PrivateRoute from '../Common/PrivateRoute';
import SideNavBar from '../Common/SideNavBar';
import Notices from './Notices/index';
import TournamentKit from './TournamentKit';
import DigitalKitDownload from './TournamentKit/DigitalKitDownload';
import DigitalKitDownloadAgreement from './TournamentKit/DigitalKitDownload/DigitalKitDownloadAgreement';
import PrintKitRequest from './TournamentKit/PrintKitRequest';
import PrintKitRequestAgreement from './TournamentKit/PrintKitRequest/PrintKitRequestAgreement';

const menus = [
  {path: '/news/notices', name: '공지사항'},
  {path: '/news/tournament-kit', name: '토너먼트 키트'},
];

class News extends Component {
  render() {
    return (
      <Layout>
        <SideNavBar title="새소식/이벤트" menus={menus} />
        <Route path="/news/notices" component={Notices} />
        <Route path="/news/tournament-kit" exact component={TournamentKit} />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM']}
          path="/news/tournament-kit/digital-kit-download/agreement"
          exact
          component={DigitalKitDownloadAgreement}
        />
        <Route path="/news/tournament-kit/digital-kit-download" exact component={DigitalKitDownload} />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM']}
          path="/news/tournament-kit/print-kit-request/agreement"
          exact
          component={PrintKitRequestAgreement}
        />
        <PrivateRoute
          allowedUserStates={['OK']}
          path="/news/tournament-kit/print-kit-request"
          exact
          component={PrintKitRequest}
        />
      </Layout>
    );
  }
}

export default News;
